export var useMapUtil = function () {
    var _a;
    if (process.env.NODE_ENV !== 'production' && !((_a = window.ymaps) === null || _a === void 0 ? void 0 : _a.util)) {
        throw new Error('Компонент необходимо обернуть в провайдер <Loader>');
    }
    return window.ymaps.util;
};
